import { Injectable } from '@angular/core';
import type { RideRequest } from '../../models/ride-request';
import { RestSanitizer } from '../rest-sanitizer.interface';
import { isNullOrUndefined } from '@uzurv/rideWss/app/util/is-null-or-defined';

@Injectable({
  providedIn: 'root'
})
export class RideRequestSanitizer implements RestSanitizer<RideRequest> {
  sanitize(rideRequest: RideRequest): RideRequest {
    if (isNullOrUndefined(rideRequest)) {
      return rideRequest;
    }

    if (rideRequest.rideRequestType?.onDemand) {
      rideRequest.pickupDate = null;
      rideRequest.dropoffDate = null;
    }

    // No Preference has a value of -1 for front end validation
    // Map that to null
    if (rideRequest.preferredProviderId === -1) {
      rideRequest.preferredProviderId = null;
    }

    return rideRequest;
  }
}
